import { Button, Typography } from '@montugroup/design-system';
import type { BoxProps } from '@mui/material';
import { Box, styled } from '@mui/material';

type BreakpointKey = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface CtaProps extends BoxProps {
  breakpoint?: BreakpointKey;
  justifyContent?: React.CSSProperties['justifyContent'];
}

// We need to provide a prop for the breakpoint since the CTA button/s appears in both the screen/page and the dialog.
export const CtaSection = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'breakpoint',
})<CtaProps>(({ theme, breakpoint = 'md', justifyContent = 'flex-end' }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent,
  gap: theme.spacing(6),
  padding: `${theme.spacing(6)} 0`,
  alignItems: 'flex-start',
  backgroundColor: 'white',
  [theme.breakpoints.down(breakpoint)]: {
    flexDirection: 'column',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    justifyContent: 'flex-end',
    padding: `${theme.spacing(6)} ${theme.spacing(6)}`,
    zIndex: 1,
    left: 0,
    gap: theme.spacing(2),
    alignItems: 'inherit',
  },
}));

export const CtaButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'breakpoint',
})<CtaProps>(({ theme, breakpoint = 'md' }) => ({
  width: '100%',
  padding: `${theme.spacing(3)} !important`,

  [theme.breakpoints.up(breakpoint)]: {
    flexGrow: 1,
    width: 'auto',
    padding: `${theme.spacing(4)} !important`,
  },
}));

export const CtaButtonText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'breakpoint',
})<CtaProps>(({ theme, breakpoint = 'md' }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.up(breakpoint)]: {
    padding: 0,
  },
}));
